import { intervalToDuration } from "date-fns";

const UNIT_ABBREVIATIONS: Array<{ key: keyof Duration; suffix: string }> = [
  { key: "months", suffix: "mo" },
  { key: "days", suffix: "d" },
  { key: "hours", suffix: "h" },
  { key: "minutes", suffix: "m" },
];

/**
 * Formats the time remaining until a shift as an abbreviated compound duration.
 * Uses date-fns intervalToDuration for accurate calendar-aware breakdown,
 * then abbreviates the two largest non-zero units (e.g., "2d 5h", "3h 22m").
 */
export function formatTimeToShift(shiftStart: Date, now: Date): string {
  if (shiftStart <= now) {
    return "Started";
  }

  const duration = intervalToDuration({ start: now, end: shiftStart });

  const parts = UNIT_ABBREVIATIONS.map(({ key, suffix }) => {
    const value = duration[key] ?? 0;
    return value > 0 ? `${String(value)}${suffix}` : undefined;
  }).filter(Boolean);

  return parts.slice(0, 2).join(" ") || "0m";
}
